// Instagram link styled as a button (gradient glyph + label). Shared by the
// support "?" popup and the first-visit survey's support panel.
// Copy-out clean: no imports outside src/pathfinder.

const IG_URL = 'https://www.instagram.com/myumaps/';

export default function InstagramButton() {
  return (
    <a className="pfa-fb-ig" href={IG_URL} target="_blank" rel="noopener noreferrer">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <defs>
          <radialGradient id="ig-grad-sp" cx="30%" cy="107%" r="150%">
            <stop offset="0%" stopColor="#fdf497" />
            <stop offset="5%" stopColor="#fdf497" />
            <stop offset="45%" stopColor="#fd5949" />
            <stop offset="60%" stopColor="#d6249f" />
            <stop offset="90%" stopColor="#285AEB" />
          </radialGradient>
        </defs>
        <rect x="2" y="2" width="20" height="20" rx="6" ry="6" fill="url(#ig-grad-sp)" />
        <circle cx="12" cy="12" r="4.5" stroke="#fff" strokeWidth="1.8" fill="none" />
        <circle cx="17.5" cy="6.5" r="1.2" fill="#fff" />
      </svg>
      Instagram
    </a>
  );
}
